import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import HeaderAdmin from "../../../components/admin/Header";
import CurrencySetting from "../../../components/admin/TabsManager/CurrencySetting";
import ExchangeRateTab from "../../../components/admin/TabsManager/ExchangeRate";
import HistoryLogs from "../../../components/admin/TabsManager/HistoryLogs";
import UserManager from "../../../components/admin/TabsManager/UserManager";
import { ROLE } from "../../../constants/admin.constants";
import { useStores } from "../../../srores";

function MainManager() {
  const navigate = useNavigate();
  const { adminStore } = useStores();
  const [selectedTab, setSelectedTab] = useState<number>(0);
  const [tabsState, setTabsState] = useState<any>(null);
  const tabs = [
    {
      value: "user-manager",
      displayName: "User management",
    },
    {
      value: "currency-setting",
      displayName: "Currency setting",
    },
    {
      value: "exchange-rate",
      displayName: "Exchange rate",
    },
    {
      value: "history-logs",
      displayName: "History logs",
    },
  ];
  const onTabClick = (index: number) => {
    setSelectedTab(index);
  };
  useEffect(() => {
    const user = localStorage.getItem("infoSignin");
    if (!user) {
      navigate("/signin");
    }
    if (user) {
      const parse = JSON.parse(user);
      let role: string;
      try {
        role = window.atob(parse.role);
      } catch (err) {
        return navigate("/signin");
      }
      if (role === ROLE.ADMIN) {
        setTabsState(tabs);
      }
      if (role === ROLE.MANAGER) {
        tabs.splice(3, 1);
        setTabsState(tabs);
      }
      adminStore.setRole(role);
    }
  }, []);
  return (
    <>
      <div className="flex-row w-[100%]">
        <HeaderAdmin verifiedToken={true} />
        {(adminStore.role === ROLE.ADMIN ||
          adminStore.role === ROLE.MANAGER) && (
          <div className="bg-[#F2F2F2] xsm:px-1 xsm:py-2 md:px-6 md:py-4 xl:px-10 xl:py-5 xsm:min-h-[calc(100vh-80px)] xs:min-h-[calc(100vh-96px)] w-full">
            <div className="flex xsm:justify-between xs:justify-start">
              {tabsState &&
                tabsState.map((tab: any, index: number) => (
                  <div
                    key={index}
                    className={`xsm:text-center xs:text-left xsm:text-[12px] xs:text-[14px]  xsm:px-1 xsm:py-2 md:px-3 md:py-1 xl:px-5 xl:py-2 rounded-t-lg shadow-md cursor-pointer ${
                      selectedTab === index
                        ? " bg-white hover:bg-[#d4d4d4] font-bold"
                        : " bg-[#EED484] hover:bg-[#dac176]"
                    }`}
                    onClick={() => {
                      onTabClick(index);
                    }}
                  >
                    {tab.displayName}
                  </div>
                ))}
            </div>
            {selectedTab === 0 ? (
              <UserManager />
            ) : selectedTab === 1 ? (
              <CurrencySetting />
            ) : selectedTab === 2 ? (
              <ExchangeRateTab />
            ) : (
              adminStore.role === ROLE.ADMIN && <HistoryLogs />
            )}
          </div>
        )}
        {adminStore.role === ROLE.STAFF && (
          <div className="bg-[#F2F2F2] xsm:px-2 xsm:py-1 md:px-6 md:py-2 xl:px-10 xl:py-5 xsm:min-h-[calc(100vh-80px)] xs:min-h-[calc(100vh-96px)] w-full">
            <ExchangeRateTab />
          </div>
        )}
      </div>
    </>
  );
}

export default observer(MainManager);
